import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";

class Account_se {
    constructor() {
        this.entity = 'account';
    }


    getPage(search, buildingId,page_, size_) {
        let formData = new FormData();
        formData.set("page", page_)
        formData.set("size", size_)
        formData.append("search", search)
        formData.append("buildingId", buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/' + this.entity + '/list',
            headers: {'Content-Type': 'application/json'},
        })
    }
    getPageOld(search, buildingId,page_, size_) {
        let formData = new FormData();
        formData.set("page", page_)
        formData.set("size", size_)
        formData.append("search", search)
        formData.append("buildingId", buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/accountOld/list',
            headers: {'Content-Type': 'application/json'},
        })
    }

    getById(id) {
        return Api.getById(this.entity, id)

    }

    getDetails(id,showAll) {
        let formData = new FormData();
        formData.set("id", id)
        formData.set("showAll", showAll)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/accountOld/details',
            headers: {'Content-Type': 'application/json'},
        })
    }


    detailsOfPanel(id,page_, size_) {
        let formData = new FormData();
        formData.set("id", id)
        formData.set("page", page_)
        formData.set("size", size_)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/' + this.entity + '/detailsOfPanel',
            headers: {'Content-Type': 'application/json'},
        })
    }



    updateAccount(buildingId,isPanel) {
        let formData = new FormData();
        formData.set("buildingId", buildingId)
        formData.set("isPanel", isPanel)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/' + this.entity + '/updateAccount',
            headers: {'Content-Type': 'application/json'},
        })
    }

    ////////////////////
    payment(model) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/paymentZarin/pay',
            data: model,
            headers: {'Content-Type': 'application/json'},
        })
    }

    getCallBack(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/paymentZarin/showResult/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }
    getUrl() {
        return BaseApi({requiresAtuh: false})({
            method: 'GET',
            url: '/public/verifyZarin',
            headers: {'Content-Type': 'application/json'},
        })
    }
    paymentBsi(model) {

        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/paymentBsi/payBsi',
            data: model,
            headers: {'Content-Type': 'application/json'},
        })
    }
    paymentParsian(model) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/paymentParsian/payParsian',
            data: model,
            headers: {'Content-Type': 'application/json'},
        })
    }


 getCallBackParsian(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/paymentParsian/showResult/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }

getCallBackBsi(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/paymentBsi/showResult/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }

    exportPdf(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/' + this.entity + '/exportPdf/?id=' + id,
            responseType: 'blob'
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', id+'.png'); //or any other extension
            document.body.appendChild(link);
            link.click();

        });
    }


    //////////
    searchBuildingUpdate(st,buildingId,from,to,page_,size_) {
        let formData = new FormData();
        formData.set("page", page_)
        formData.set("size", size_)
        formData.append("statue", st)
        formData.append("buildingId", buildingId)
        formData.append("from", from)
        formData.append("to", to)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/buildingUpdate/search',
            headers: {'Content-Type': 'application/json'},
        })
    }
    listBuildingUpdate() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/buildingUpdate/list',
            headers: {'Content-Type': 'application/json'},
        })
    }
    updateAccount_BuildingUpdate(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/buildingUpdate/updateAccount/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }


}

export default new Account_se();
